export enum GROUP_NAME {
  FULL_PROJECT = 'FullProjectGroup',
  MINIMAL_CLIENT = 'MinimalClient',
  MINIMAL_COMMERCIAL_PROJECT = 'MinimalCommercialProject',
  MINIMAL_PROJECT_SUIVI_INSTRUCTION = 'MinimalProjectSuiviInstruction',
  PROJECT_TUNNEL_PAGE = 'ProjectTunnelPage',
  PROJECT_TASK_PAGE = 'ProjectTaskPage',
  PROFILE = 'Profile',
  DASHBOARD_EMPLOYEE_FILTER = 'DashboardEmployeeFilter',
  DASHBOARD_TASKS = 'DashboardTasks',
  DASHBOARD_ALERTS = 'DashboardAlerts',
  CUSTOMER_FOR_NEW_R1_SEARCH = 'CustomerForNewR1Search',
  EMPLOYEE_MODAL = 'EmployeeModal',
  PROJECT_INFORMATION_DOCUMENT = 'ProjectInformationDocument',
  PROJECT_DOCUMENT_PAGE = 'ProjectDocumentPage',
  CONFIGURATION_CARD_CATALOGUE = 'ConfigurationCardCatalogue',
  MINIMAL_PROJECT = 'MinimalProject',
  CATALOGUE_FOR_TUNNEL = 'CatalogueForTunnel',
  PROJECT_FOR_PAGE_SIGNATURE = 'ProjectForPageSignature',
  PROJECT_FOR_PAGE_CUSTOMER_PROJECT = 'ProjectForPageCustomerProject',
  CUSTOMER_FOR_PAGE_CUSTOMER_PROJECT = 'CustomerFormPageCustomerProject',
  CUSTOMER_PROJECT_SEARCH = 'CustomerAndProjectSearch',
  MESSAGE_FOR_PROJECT_TASK = 'MessageForProjectTask',
  DOCUMENT_FOR_SEND_ACCESS_MODAL = 'DocumentForSendAccessModal',
  MINIMAL_PING_CUSTOMER = 'MinimalPingCustomer',
  FULL_UPSELL = 'FullUpsellGroup',
  CATALOGUE_FOR_PAGE_UPSELL = 'CatalogueForPageUpsell',
  PROJECTS_FOR_CUSTOMER_AREA = 'ProjectsForCustomerArea',
  CATALOGUE_FOR_CUSTOMER_AREA = 'CatalogueForCustomerArea',
  TASK_FOR_CUSTOMER_AREA = 'TaskForCustomerArea',
  DOCUMENT_FOR_CUSTOMER_AREA = 'DocumentForCustomerArea',
  PROJECT_FOR_DOC_ARCHIVES = 'ProjectForDocArchives',
  UPSELL_FOR_DOC_ARCHIVES = 'UpsellForDocArchives',
  OPTIONS_FOR_ARCHIVES_PAGES = 'OptionsForArchivesPages',
  STUDIOS_FOR_ARCHIVES_PAGES = 'StudiosForArchivesPages',
  M_F_E_FOR_ARCHIVES_PAGES = 'MFEForArchivesPages',
  FULL_CONFIGURATIONS = 'FullConfiguration',
  TASK_FOR_SUIVI_INSTRUCTION = 'TaskForSuiviInstruction',
  CATALOGUE_FOR_ARCHIVE_PAGE = 'CatalogueForArchivePage',
}
